import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import AdminLogin from './AdminLogin';
import Recipients from './Recipients';
import Logs from './Logs';
import Submissions from './Submissions';
import Users from './Users';

function AdminNav({ username, onLogout }) {
  const location = useLocation();
  const nav = useNavigate();
  const links = [
    { path: '/admin/recipients', label: 'Recipients' },
    { path: '/admin/logs', label: 'Submission Logs' },
    { path: '/admin/submissions', label: 'Backups' },
    { path: '/admin/users', label: 'Admin Users' },
  ];
  return (
    <div>
      <div className="admin-header">
        <h1>MCS Driver App — Admin</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>Logged in as <strong>{username}</strong></span>
          <button className="logout-btn" onClick={onLogout}>Logout</button>
        </div>
      </div>
      <div className="admin-nav">
        {links.map(l => (
          <span key={l.path} className={`admin-nav-link ${location.pathname === l.path ? 'active' : ''}`}
            onClick={() => nav(l.path)}>{l.label}</span>
        ))}
      </div>
    </div>
  );
}

function ProtectedRoute({ children, auth, username, onLogout }) {
  if (!auth) return <Navigate to="/admin/login" replace />;
  return (
    <div className="admin-layout">
      <AdminNav username={username} onLogout={onLogout} />
      <div className="admin-content">{children}</div>
    </div>
  );
}

export default function AdminApp() {
  const [auth, setAuth] = useState(null); // null=loading, false=not authed, true=authed
  const [username, setUsername] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/admin/check')
      .then(r => { setAuth(true); setUsername(r.data.username); })
      .catch(() => setAuth(false));
  }, []);

  const handleLogin = (uname) => { setAuth(true); setUsername(uname); navigate('/admin/recipients'); };
  const handleLogout = async () => {
    await axios.post('/api/admin/logout').catch(() => {});
    setAuth(false);
    setUsername('');
    navigate('/admin/login');
  };

  if (auth === null) return <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>;

  return (
    <Routes>
      <Route path="login" element={auth ? <Navigate to="/admin/recipients" replace /> : <AdminLogin onLogin={handleLogin} />} />
      <Route path="recipients" element={<ProtectedRoute auth={auth} username={username} onLogout={handleLogout}><Recipients /></ProtectedRoute>} />
      <Route path="logs" element={<ProtectedRoute auth={auth} username={username} onLogout={handleLogout}><Logs /></ProtectedRoute>} />
      <Route path="submissions" element={<ProtectedRoute auth={auth} username={username} onLogout={handleLogout}><Submissions /></ProtectedRoute>} />
      <Route path="users" element={<ProtectedRoute auth={auth} username={username} onLogout={handleLogout}><Users /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to={auth ? '/admin/recipients' : '/admin/login'} replace />} />
    </Routes>
  );
}
